import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { WhyWeContainer, WhyWeTile, WhyWeTiles } from './styled.components';
import {
  FlexColumnContainer,
  H2Style,
  H4Style,
  ParagraphMediumStyle,
  ParagraphSmallStyle,
  H3Style
} from '../../styled.components';
import { StaticImage } from 'gatsby-plugin-image';

const WhyWeSection = () => {
  const { t } = useTranslation();

  const items = [
    {
      image: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none">
          <path
            d="M32.4999 20.9536L19.9999 33.3336L7.49993 20.9536C6.67544 20.1513 6.026 19.187 5.59251 18.1214C5.15902 17.0557 4.95087 15.9119 4.98116 14.7618C5.01145 13.6118 5.27954 12.4805 5.76853 11.4392C6.25752 10.3979 6.95682 9.46905 7.82241 8.71126C8.68799 7.95347 9.70111 7.38311 10.798 7.0361C11.8948 6.68908 13.0516 6.57293 14.1955 6.69496C15.3395 6.81699 16.4458 7.17456 17.4447 7.74514C18.4437 8.31572 19.3137 9.08696 19.9999 10.0103C20.6892 9.09366 21.5602 8.32916 22.5584 7.76464C23.5567 7.20011 24.6608 6.84771 25.8015 6.72949C26.9422 6.61128 28.0951 6.72979 29.1879 7.07761C30.2807 7.42544 31.29 7.99508 32.1525 8.7509C33.0151 9.50672 33.7123 10.4324 34.2006 11.4701C34.689 12.5078 34.9578 13.6351 34.9904 14.7815C35.0231 15.9278 34.8187 17.0686 34.3902 18.1324C33.9616 19.1961 33.3181 20.16 32.4999 20.9636M19.9999 10L14.5116 15.4883C14.1992 15.8009 14.0236 16.2247 14.0236 16.6667C14.0236 17.1086 14.1992 17.5325 14.5116 17.845L15.4166 18.75C16.5666 19.9 18.4333 19.9 19.5833 18.75L21.2499 17.0833C22.2445 16.0888 23.5934 15.53 24.9999 15.53C26.4065 15.53 27.7554 16.0888 28.7499 17.0833L32.4999 20.8333M20.8333 25.8333L24.1666 29.1667M24.9999 21.6667L28.3333 25"
            stroke="#F2EDF7"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      title: t`for-companies.ww-item-title1`,
      description: t`for-companies.ww-item-description1`
    },
    {
      image: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none">
          <path
            d="M9.88501 11.5599L12.01 18.6416M21.355 27.9899L28.44 30.1149M19.4716 20.5283L29.0699 10.93M6.66663 9.1665C6.66663 9.49481 6.73129 9.8199 6.85693 10.1232C6.98256 10.4265 7.16671 10.7021 7.39886 10.9343C7.63101 11.1664 7.9066 11.3506 8.20992 11.4762C8.51323 11.6018 8.83832 11.6665 9.16663 11.6665C9.49493 11.6665 9.82002 11.6018 10.1233 11.4762C10.4266 11.3506 10.7022 11.1664 10.9344 10.9343C11.1665 10.7021 11.3507 10.4265 11.4763 10.1232C11.602 9.8199 11.6666 9.49481 11.6666 9.1665C11.6666 8.8382 11.602 8.51311 11.4763 8.2098C11.3507 7.90648 11.1665 7.63088 10.9344 7.39874C10.7022 7.16659 10.4266 6.98244 10.1233 6.8568C9.82002 6.73117 9.49493 6.6665 9.16663 6.6665C8.83832 6.6665 8.51323 6.73117 8.20992 6.8568C7.9066 6.98244 7.63101 7.16659 7.39886 7.39874C7.16671 7.63088 6.98256 7.90648 6.85693 8.2098C6.73129 8.51311 6.66663 8.8382 6.66663 9.1665ZM28.3333 9.1665C28.3333 9.82955 28.5967 10.4654 29.0655 10.9343C29.5344 11.4031 30.1703 11.6665 30.8333 11.6665C31.4963 11.6665 32.1322 11.4031 32.6011 10.9343C33.0699 10.4654 33.3333 9.82955 33.3333 9.1665C33.3333 8.50346 33.0699 7.86758 32.6011 7.39874C32.1322 6.9299 31.4963 6.6665 30.8333 6.6665C30.1703 6.6665 29.5344 6.9299 29.0655 7.39874C28.5967 7.86758 28.3333 8.50346 28.3333 9.1665ZM28.3333 30.8332C28.3333 31.4962 28.5967 32.1321 29.0655 32.6009C29.5344 33.0698 30.1703 33.3332 30.8333 33.3332C31.4963 33.3332 32.1322 33.0698 32.6011 32.6009C33.0699 32.1321 33.3333 31.4962 33.3333 30.8332C33.3333 30.1701 33.0699 29.5342 32.6011 29.0654C32.1322 28.5966 31.4963 28.3332 30.8333 28.3332C30.1703 28.3332 29.5344 28.5966 29.0655 29.0654C28.5967 29.5342 28.3333 30.1701 28.3333 30.8332ZM6.66663 25.8332C6.66663 27.8223 7.4568 29.7299 8.86332 31.1365C10.2698 32.543 12.1775 33.3332 14.1666 33.3332C16.1557 33.3332 18.0634 32.543 19.4699 31.1365C20.8764 29.7299 21.6666 27.8223 21.6666 25.8332C21.6666 23.844 20.8764 21.9364 19.4699 20.5299C18.0634 19.1233 16.1557 18.3332 14.1666 18.3332C12.1775 18.3332 10.2698 19.1233 8.86332 20.5299C7.4568 21.9364 6.66663 23.844 6.66663 25.8332Z"
            stroke="#F2EDF7"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      title: t`for-companies.ww-item-title2`,
      description: t`for-companies.ww-item-description2`
    },
    {
      image: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none">
          <path
            d="M5 20H6.66667M20 5V6.66667M33.3333 20H35M9.33333 9.33333L10.5 10.5M30.6667 9.33333L29.5 10.5M16.1666 28.3333H23.8333M15 26.6667C13.6008 25.6173 12.5672 24.1542 12.0457 22.4847C11.5242 20.8153 11.5412 19.024 12.0943 17.3648C12.6474 15.7055 13.7085 14.2623 15.1274 13.2396C16.5463 12.217 18.251 11.6667 20 11.6667C21.749 11.6667 23.4537 12.217 24.8726 13.2396C26.2915 14.2623 27.3526 15.7055 27.9057 17.3648C28.4588 19.024 28.4758 20.8153 27.9543 22.4847C27.4328 24.1542 26.3992 25.6173 25 26.6667C24.3493 27.3108 23.8593 28.0991 23.5698 28.9677C23.2802 29.8363 23.1992 30.7609 23.3333 31.6667C23.3333 32.5507 22.9821 33.3986 22.357 34.0237C21.7319 34.6488 20.8841 35 20 35C19.1159 35 18.2681 34.6488 17.643 34.0237C17.0179 33.3986 16.6667 32.5507 16.6667 31.6667C16.8008 30.7609 16.7198 29.8363 16.4302 28.9677C16.1407 28.0991 15.6507 27.3108 15 26.6667Z"
            stroke="#F2EDF7"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      title: t`for-companies.ww-item-title3`,
      description: t`for-companies.ww-item-description3`
    },
    {
      image: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none">
          <path
            d="M20 6.6665V11.6665M13.3333 6.6665V16.6665M26.6667 6.6665V16.6665M20 30.8332L15 33.3332L15.8333 27.4998L12.5 24.1665L17.5 23.3332L20 18.3332L22.5 23.3332L27.5 24.1665L24.1667 27.4998L25 33.3332L20 30.8332Z"
            stroke="#F2EDF7"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      title: t`for-companies.ww-item-title4`,
      description: t`for-companies.ww-item-description4`
    },
    {
      image: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none">
          <path
            d="M13.3333 18.3332L6.66663 21.6665V29.9998L13.3333 33.3332L20 29.9998M13.3333 18.3332L20 21.6665M13.3333 18.3332V9.99984L20 6.6665L26.6666 9.99984V18.3332M20 21.6665V29.9998M20 21.6665L26.6666 18.3332M20 29.9998L26.6666 33.3332L33.3333 29.9998V21.6665L26.6666 18.3332"
            stroke="#F2EDF7"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      title: t`for-companies.ww-item-title5`,
      description: t`for-companies.ww-item-description5`
    }
  ];

  const renderItems = (items) => {
    return items?.map((item, index) => (
      <WhyWeTile key={index}>
        <FlexColumnContainer alignItems="flex-start" gap="8px">
          {item.image}
          <H3Style>{item.title}</H3Style>
          <ParagraphSmallStyle lineHeight="170%" opacity={0.7}>
            {item.description}
          </ParagraphSmallStyle>
        </FlexColumnContainer>
      </WhyWeTile>
    ));
  };

  return (
    <>
      <WhyWeContainer>
        <StaticImage
          className="circle-image circle1"
          src="../../../../images/for-companies/ww/circle1.webp"
          alt="image"
          placeholder="none"
          loading="lazy"
        />
        <StaticImage
          className="circle-image circle2"
          src="../../../../images/for-companies/ww/circle2.webp"
          alt="image"
          placeholder="none"
          loading="lazy"
        />
        {/* <StaticImage
          className="circle-image circle3"
          src="../../../../images/for-companies/ww/circle3.webp"
          alt="image"
          placeholder="none"
          loading="lazy"
        /> */}
        <div className="container">
          <FlexColumnContainer
            alignItems="flex-start"
            gap="24px"
            className="ww-header">
            <FlexColumnContainer alignItems="flex-start" gap="8px">
              <H4Style textTransform="uppercase">{t`for-companies.ww-title`}</H4Style>
              <H2Style fontWeight="700">{t`for-companies.ww-title2`}</H2Style>
            </FlexColumnContainer>
            <ParagraphMediumStyle
              fontWeight={350}
              opacity={
                0.7
              }>{t`for-companies.ww-description`}</ParagraphMediumStyle>
          </FlexColumnContainer>
          <WhyWeTiles>
            {renderItems(items)}{' '}
            <StaticImage
              className="circle3"
              src="../../../../images/for-companies/ww/circle3.webp"
              alt="image"
              placeholder="none"
              loading="lazy"
            />
          </WhyWeTiles>
        </div>
      </WhyWeContainer>
    </>
  );
};

export default WhyWeSection;
